import React, { useGlobal } from "reactn";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { deleteSetCookie, getCookie } from "../../helpers/Helpers";
import SwitchProfileButtonStyled from "./SwitchProfileButton.styled";
import DetectDeviceResize from "../../hooks/detectDeviceResizeHook";


const SwitchProfileButton = ({ collapsed, className, isOverview }) => {
	const history = useHistory();

	// set global state for business profile
	const [isBusiness, setIsBusiness] = useGlobal("isBusiness");
	const [userProfile, setIsUserProfile] = useGlobal("userProfile");
	const [showBusinessBanner, setShowBusinessBanner] = useGlobal("businessBanner");
	const [callSideNav, setcallSideNav] = useGlobal("callSideNav");

	// hooks
	const { isMobile } = DetectDeviceResize();

	// when click on switch profile button, set business to true and check for cookie. If it exists, delete it on click, if not set it
	// set /business in the url if business account and overview tab, or remove when switching to personal, this will re-render the HomePage component
	const handleClick = e => {
		e.preventDefault();

		// if it's not a business and doesn't have a cookie set
		if (!isBusiness && !getCookie("switch_profile")) {
			setIsBusiness(true);
			setShowBusinessBanner(true);
			document.cookie = "switch_profile=true";
			if (isOverview) history.replace("/Business");
			setcallSideNav(true);
		} else {
			setIsBusiness(false);
			setcallSideNav(true);
			setShowBusinessBanner(false);
			deleteSetCookie("switch_profile=true");
			if (isOverview) {
				const uri = window.location.href.toString();
				const cleanUri = uri.substring(0, uri.indexOf("/Business"));
				window.history.replaceState({}, document.title, cleanUri);
			}
		}

		if (isBusiness && userProfile.profile.business.name) {
			setShowBusinessBanner(false);
		}
	};

	return (
		<SwitchProfileButtonStyled className={className} type="button" onClick={handleClick} mobile={isMobile} isBusiness={isBusiness}>
			{isMobile ?
				<svg aria-hidden="true" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path 
						fillRule="evenodd" 
						clipRule="evenodd" 
						d="M8.70747 0.293253C8.31714 -0.0974698 7.68398 -0.0977921 7.29325 0.292533C6.90253 0.682859 6.90221 1.31602 7.29253 1.70675L8.58447 3L3 3C1.34315 3 0 4.34315 0 6L0 7.5C0 8.05229 0.447715 8.5 1 8.5C1.55228 8.5 2 8.05229 2 7.5L2 6C2 5.44772 2.44772 5 3 5L8.58447 5L7.29253 6.29325C6.90221 6.68398 6.90253 7.31714 7.29325 7.70747C7.68398 8.09779 8.31714 8.09747 8.70747 7.70675L11.7044 4.70674C12.0945 4.3163 12.0945 3.68369 11.7044 3.29325L8.70747 0.293253ZM5.28948 15.7067C5.67981 16.0975 6.31297 16.0978 6.70369 15.7075C7.09442 15.3171 7.09474 14.684 6.70441 14.2933L5.41248 13L10.9969 13C12.6538 13 13.9969 11.6569 13.9969 10V8.5C13.9969 7.94772 13.5492 7.5 12.9969 7.5C12.4447 7.5 11.9969 7.94772 11.9969 8.5V10C11.9969 10.5523 11.5492 11 10.9969 11L5.41248 11L6.70442 9.70675C7.09474 9.31602 7.09442 8.68286 6.7037 8.29253C6.31297 7.90221 5.67981 7.90253 5.28948 8.29325L2.29254 11.2933C1.90249 11.6837 1.90249 12.3163 2.29254 12.7067L5.28948 15.7067Z" 
						fill={isBusiness ? "#006150" : "#003D4C"}
					/>
				</svg>
				:
				<svg aria-hidden="true" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="48" height="48" rx="5" transform="matrix(-1 0 0 1 48 0)" fill="#fff" fillOpacity=".1" />
					<g clipPath="url(#a)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M25.707 16.293a1 1 0 1 0-1.415 1.414L25.585 19H20a3 3 0 0 0-3 3v1.5a1 1 0 1 0 2 0V22a1 1 0 0 1 1-1h5.584l-1.291 1.293a1 1 0 1 0 1.415 1.414l2.996-3a1 1 0 0 0 0-1.414l-2.997-3ZM22.29 31.707a1 1 0 1 0 1.415-1.414L22.413 29h5.584a3 3 0 0 0 3-3v-1.5a1 1 0 1 0-2 0V26a1 1 0 0 1-1 1h-5.584l1.291-1.293a1 1 0 0 0-1.415-1.414l-2.997 3a1 1 0 0 0 0 1.414l2.997 3Z"
							fill="#fff"
						/>
					</g>
					<defs>
						<clipPath id="switch__clip">
							<path fill="#fff" transform="translate(16 16)" d="M0 0h16v16H0z" />
						</clipPath>
					</defs>
				</svg>
			}
			{!collapsed ? `${isMobile ? "Switch" : "Go"} to ${isBusiness ? "Personal" : "Business"}` : ""}
		</SwitchProfileButtonStyled>
	);
};

export default SwitchProfileButton;

SwitchProfileButton.propTypes = {
	className: PropTypes.string,
	collapsed: PropTypes.bool,
	isOverview: PropTypes.bool
};